import React, { useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import qs from 'qs';
import styles from './index.module.scss';

import { useAuthGuard, useMutation } from 'utils/hooks';
import { logout } from 'utils/services';
import ssImage from 'assets/ss-icons/shipstation-icon.png';

export default function SellerSignIn() {
  const { search } = useLocation();
  const { replace } = useHistory();

  const { onAuthenticated } = useAuthGuard();

  const { redirect_path: redirectPath = '/', ...queryData } = qs.parse(search, {
    ignoreQueryPrefix: true
  });

  const { mutate: signIn } = useMutation('auth.sellerSignIn', 'POST', {
    payload: { ...(queryData || {}) },
    errorMessage: "We couldn't log you in.",
    onSuccess: data => onAuthenticated(data, redirectPath),
    onError: () => replace('/login')
  });

  useEffect(() => {
    logout(() => signIn());
  }, [signIn]);

  return (
    <div className={styles.container}>
      <img className={styles.ssImage} src={ssImage} alt="not found" />
      <span className={styles.content}>
        Provisioning access to configuration portal...
      </span>
    </div>
  );
}
